// Mock data for Altınzade Kuyumcu website

export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      collections: 'Koleksiyonlar',
      about: 'Hakkımızda',
      contact: 'İletişim',
    },
    hero: {
      tagline: 'Zarafet ve Güvenin Adresi',
      subtitle: 'Kıbrıs\'ın en seçkin mücevher koleksiyonu',
      cta: 'Koleksiyonları Keşfet',
    },
    collections: {
      title: 'Koleksiyonlar',
      subtitle: 'Eşsiz parçalarımızı keşfedin',
      viewAll: 'Tümünü Gör',
    },
    about: {
      title: 'Hikayemiz',
      subtitle: 'Nesiller Boyu Güven',
      description: 'Altınzade Kuyumculuk, aileden gelen uzmanlık ve kusursuz hizmet anlayışıyla Kıbrıs\'ta mücevher sektörünün güvenilir adresi olmaya devam ediyor. Her müşterimizi ailemizin bir parçası olarak görüyor, en kaliteli ürünleri sunmak için özveriyle çalışıyoruz.',
      story: {
        p1: 'Altınzade Kuyumculuk, Kıbrıs\'ta mücevher sektörünün en güvenilir isimlerinden biri olarak, aileden gelen uzmanlık ve kusursuz hizmet anlayışıyla hizmet vermektedir.',
        p2: 'Her müşterimizi ailemizin bir parçası olarak görüyor, en kaliteli ürünleri sunmak için özveriyle çalışıyoruz. Nesiller boyu süren deneyimimizle, size en değerli anlarınız için en özel parçaları sunuyoruz.',
        p3: 'Lefkoşa\'nın kalbinde, METROPOL\'de bulunan mağazamızda sizleri ağırlamaktan mutluluk duyarız.',
      },
      values: { heading: 'Değerlerimiz' },
      value1: { title: 'Güven', description: 'Nesiller boyu süren güvenilirlik' },
      value2: { title: 'Kalite', description: 'En seçkin malzemeler ve ustalık' },
      value3: { title: 'Aile', description: 'Her müşterimiz ailemizin bir parçası' },
    },
    reviews: {
      title: 'Müşterilerimiz Ne Diyor',
      subtitle: 'Güven ve memnuniyet',
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Sizinle tanışmak için sabırsızlanıyoruz',
      whatsapp: 'WhatsApp\'tan Bilgi Al',
      address: 'Adres',
      phone: 'Telefon',
      visitUs: 'Bizi Ziyaret Edin',
    },
    product: {
      karat: 'Ayar',
      contact: 'WhatsApp\'tan Bilgi Al',
    },
    footer: {
      rights: 'Tüm hakları saklıdır.',
      followUs: 'Bizi Takip Edin',
      tagline: 'Kıbrıs\'ta mücevher sektörünün güvenilir adresi. Nesiller boyu süren ustalık ve kalite.',
      quickLinks: 'Hızlı Bağlantılar',
      contactInfo: 'İletişim',
    },
  },
  en: {
    nav: {
      home: 'Home',
      collections: 'Collections',
      about: 'About Us',
      contact: 'Contact',
    },
    hero: {
      tagline: 'Where Elegance Meets Trust',
      subtitle: 'Cyprus\'s finest jewellery collection',
      cta: 'Explore Collections',
    },
    collections: {
      title: 'Collections',
      subtitle: 'Discover our exceptional pieces',
      viewAll: 'View All',
    },
    about: {
      title: 'Our Story',
      subtitle: 'Generations of Trust',
      description: 'Altınzade Jewellery continues to be the trusted address in the jewellery sector in Cyprus with expertise inherited from family and impeccable service understanding. We consider each of our customers as part of our family and work with dedication to offer the highest quality products.',
      story: {
        p1: 'Altınzade Jewellery, as one of the most trusted names in the jewellery sector in Cyprus, serves with expertise inherited from family and impeccable service understanding.',
        p2: 'We consider each of our customers as part of our family and work with dedication to offer the highest quality products. With our experience spanning generations, we offer you the most special pieces for your most precious moments.',
        p3: 'We would be happy to welcome you to our store located in METROPOL, in the heart of Nicosia.',
      },
      values: { heading: 'Our Values' },
      value1: { title: 'Trust', description: 'Reliability spanning generations' },
      value2: { title: 'Quality', description: 'Finest materials and craftsmanship' },
      value3: { title: 'Family', description: 'Every customer is part of our family' },
    },
    reviews: {
      title: 'What Our Customers Say',
      subtitle: 'Trust and satisfaction',
    },
    contact: {
      title: 'Contact',
      subtitle: 'We look forward to meeting you',
      whatsapp: 'Contact via WhatsApp',
      address: 'Address',
      phone: 'Phone',
      visitUs: 'Visit Us',
    },
    product: {
      karat: 'Karat',
      contact: 'Contact via WhatsApp',
    },
    footer: {
      rights: 'All rights reserved.',
      followUs: 'Follow Us',
      tagline: 'The trusted address in the jewellery sector in Cyprus. Generations of craftsmanship and quality.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact',
    },
  },
};
